import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Informacion, ValoresFormulario } from './interfaces/summary.interface';
import { CommmonService } from 'src/app/utils/common.service';
import { RequestFormService } from 'src/app/home/services/request-form.service';

@Injectable({
  providedIn: 'root',
})
export class RequestUtilsService {
  Id_token_claims_obj = JSON.parse(
    this.commonService.getItemSessionStorage('id_token_claims_obj') ?? '[]',
  );

  constructor(
    private http: HttpClient,
    private commonService:CommmonService,
    private request_service: RequestFormService
  ){}


  button_correction(selectstatus: string, correction: boolean) {
    if (selectstatus === 'Enviada' && !correction) {
     correction = true;
    } else if (selectstatus === 'Enviada' && correction) {
     correction = false;
    }
    return correction
  }

  save_selected_data(event: any, title: string, storageData:any, order:string[]) {
    const existingIndex = storageData.findIndex(
      (item:any) => item.title === title,
    );
    if (event.target.checked) {
      if (existingIndex === -1) {
        storageData.push({
          title: title,
          data: [
            {
              key: event.target.name,
              value: event.target.value,
              status: event.target.checked,
            },
          ],
        });
      } else {
        storageData[existingIndex].data.push({
          key: event.target.name,
          value: event.target.value,
          status: event.target.checked,
        });
      }
      storageData.sort(
        (a:any, b:any) => order.indexOf(a.title) - order.indexOf(b.title),
      );
    } else {
      if (existingIndex !== -1) {
        const dataIndex = storageData[existingIndex].data.findIndex(
          (data:any) => data.key === event.target.name,
        );
        if (dataIndex !== -1) {
          storageData[existingIndex].data.splice(dataIndex, 1);
        }
        if (storageData[existingIndex].data.length === 0) {
          storageData.splice(existingIndex, 1);
        }
      }
    }
    return storageData;
  }

  get_icon_status(status:string): any {
    switch (status) {
      case 'Aprobada':
        return '/assets/icon-summary/icon-approved.svg';
      case 'Rechazada':
        return '/assets/icon-summary/icon-rejected.svg';
      case 'Con error':
        return '/assets/icon-summary/icon-warning-rigth.svg';
      case 'Anulada':
          return '/assets/icon-summary/icon-anulada.svg'; 
    }
  }

  async download_file(file: string) {
    const payload = {
      "objeto":file
    };
    return await this.request_service.get_url_donwload_file(payload);
  }

  toggleCorregir(summarydata:any, section: any, key: string | number, cancel?: boolean) {
    const dataSection = summarydata[section];
    if (section === 'archivos') {
      const archivos = dataSection as ValoresFormulario[];
      if (cancel) {
        archivos.forEach(item => item.corregir = false);
      } else if (typeof key === 'number' && archivos[key]) {
        archivos[key].corregir = !archivos[key].corregir;
      }
      return;
    }
    if (cancel) {
      for (let campo in dataSection) {
        if (dataSection.hasOwnProperty(campo)) {
          (dataSection as Informacion)[campo].corregir = false;
        }
      }
    } else if (key) {
      (dataSection as Informacion)[key].corregir = !(dataSection as Informacion)[key].corregir;
    }
  }

  isFieldsDisabled(key:string){
    if(this.isEmployeeCopec()){
      const disabledFields = ['Nombres', 'Apellidos', 'RUT', 'Email', 'Monto_solicitado'];
       return disabledFields.includes(key);
    }
    return false;
  }

  isEmployeeCopec() { 
    if (!Object.keys(this.Id_token_claims_obj.userData).length) {
      return false;
    } else {
      return true;
    }
  }

  getOrderedFields(data: any): any[] {
    return Object.keys(data)
      .map(key => ({ key, ...data[key] }))
      .sort((a, b) => a.index - b.index);
  }

  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
  isObjectEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  
}
